import { FunctionComponent } from 'react';
import {
	Select,
	SelectOptionType,
} from '@montel/montelpro-shared-components-v2';
import { Company } from 'domain/company/Company';

interface CompanySelectProps {
	companies: Company[];
	value: number | null;
	onChange: (companyId: number) => void;
	loading?: boolean;
	label?: string;
	required?: boolean;
	disabled?: boolean;
}

export const CompanySelect: FunctionComponent<CompanySelectProps> = ({
	companies,
	value,
	onChange,
	loading = false,
	label = 'Company',
	required = false,
	disabled = false,
}) => {
	const options =
		companies?.map((company) => ({
			value: company.id,
			label: company.youniumAccountNumber
				? `${company.name} (${company.youniumAccountNumber})`
				: company.name,
		})) || [];

	options.sort((a, b) => a.label.localeCompare(b.label));

	const selectedOption =
		value != null
			? options.find((option) => option.value === value) || null
			: null;

	return (
		<Select
			label={label}
			disabled={loading || disabled}
			required={required}
			options={options}
			value={selectedOption}
			placeholder={
				loading
					? 'Loading...'
					: 'Select a company, or search for one...'
			}
			onChange={(option: SelectOptionType) => onChange(option.value)}
		/>
	);
};
